<div class="search-bar-container">
  <div class="search-input-wrapper">
    <i class="pi pi-search search-icon"></i>
    <input
      pInputText
      type="text"
      [placeholder]="placeholder"
      [value]="value"
      (input)="onSearchChange($event)"
      class="search-input"
    />
  </div>
</div>
